<div [class.container]="isVerticalLayout$ | async" class="toolbar w-full px-2 sm:px-4 flex items-center shadow-lg">


  <button (click)="openSidenav()" [class.hidden]="!mobileQuery" mat-icon-button type="button">
    <mat-icon svgIcon="mat:menu"></mat-icon>
  </button>


  <button (click)="toggleCollapse()"
    class="w-8 h-8 p-0 leading-none hidden lg:!block"
    mat-icon-button
    type="button">
    @if (!collapsed) {
      <mat-icon class="text-[0.875rem] w-[0.875rem] h-[0.875rem]" svgIcon="mat:radio_button_checked"></mat-icon>
    }@else {
      <mat-icon
        class="text-[0.875rem] w-[0.875rem] h-[0.875rem]"
      svgIcon="mat:radio_button_unchecked"></mat-icon>
    }
  </button>

  <button mat-flat-button type="button" class="mr-2 ml-2" color="accent" style="font-size:14px !important;">
    {{envName}}
  </button>


@if ((isVerticalLayout$ | async) && isNavbarInToolbar$ | async) {
  <div
    [class.hidden]="mobileQuery"
    class="px-gutter flex-none flex items-center">
    @for (item of navigationItems; track item) {
      <vex-navigation-item [item]="item"></vex-navigation-item>
    }
  </div>
}

<span class="flex-1"></span>

<div class="-mx-1 flex items-center">
  <app-fixtures-button></app-fixtures-button>
  <!--    <div class="px-1">-->
  <!--      <button (click)="openSearch()" mat-icon-button type="button">-->
  <!--        <mat-icon color="primary" svgIcon="mat:search"></mat-icon>-->
<!--      </button>-->
<!--    </div>-->



<!--    <div class="px-1">-->
<!--      <button (click)="openQuickpanel()" mat-icon-button type="button">-->
<!--        <mat-icon color="primary" svgIcon="mat:bookmarks"></mat-icon>-->
<!--      </button>-->
<!--    </div>-->

<!--    <div class="px-1">-->
<!--      <button [matMenuTriggerFor]="languageMenu" mat-icon-button type="button">-->
<!--        <mat-icon svgIcon="flag:united-states"></mat-icon>-->
<!--      </button>-->
<!--    </div>-->

@if (userVisible$ | async) {
  <div class="px-1">
    <vex-toolbar-user></vex-toolbar-user>
  </div>
}

<!--    <div class="px-1">-->
<!--      <vex-toolbar-notifications></vex-toolbar-notifications>-->
<!--    </div>-->

<div class="px-1">
  <button mat-icon-button color="primary" matTooltip="Přihlašovací token" [cdkCopyToClipboard]="authService.currentUser.token">
    <mat-icon svgIcon="mat:vpn_key"></mat-icon>
  </button>
</div>
<div class="px-1">
  <button mat-icon-button color="primary" matTooltip="Explorer" (click)="openURL(apiUrl + '/explorer')">
    <mat-icon svgIcon="mat:api"></mat-icon>
  </button>
</div>
<div class="px-1">
  <button mat-icon-button color="primary" (click)="openURL(frontendUrl)" matTooltip="Zobrazit web">
    <mat-icon svgIcon="mat:launch"></mat-icon>
  </button>
</div>

<!--    <mat-menu #languageMenu="matMenu" overlapTrigger="false" xPosition="before" yPosition="below">-->
<!--      <button mat-menu-item>-->
<!--        <mat-icon svgIcon="flag:united-states"></mat-icon>-->
<!--        <span>English</span>-->
<!--      </button>-->

<!--      <button mat-menu-item>-->
<!--        <mat-icon svgIcon="flag:germany"></mat-icon>-->
<!--        <span>German</span>-->
<!--      </button>-->
<!--    </mat-menu>-->
</div>
</div>

@if ((isVerticalLayout$ | async) && isNavbarBelowToolbar$ | async) {
  <vex-navigation  [class.hidden]="mobileQuery"></vex-navigation>
}
